import { Injectable } from '@angular/core';

function __window(){
  return window;
}

@Injectable()
export class WindowService {

  constructor() { }

  get nativeWindow():any{
    return __window;
  }

  removeMainSlider(){
    delete this.nativeWindow.THREE;
    delete this.nativeWindow.TimelineMax;
    delete this.nativeWindow.TweenLite;
    delete this.nativeWindow.TweenMax;
    delete this.nativeWindow.TweenPlugin;
    delete this.nativeWindow.sliderEffect;
    delete this.nativeWindow.GreenSockGlobals;
  }

}



// WEBPACK FOOTER //
// ./src/app/window.service.ts